import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Table, Card, CardBody, CardTitle, Button } from "reactstrap";
import { useLocation } from "react-router-dom";
import Pagination from "../../../../components/Paginationv3";
import { fetchPackages } from "../../../../utils/services/portalBoticario";
import { ModalNewPackage } from "./modals/ModalNewPackage";
import { ModalEditPackage } from "./modals/ModalEditPackage";
import ActionButtonRounded from "../../../../components/Buttons/ActionButtonRounded";
// Componentes
import LoadingSkelentonTable from "../../../../components/loadingSkeletonTable";

const PackagesPerGroup = (props) => {
  const location = useLocation();
  const token = props.state.global_user_data.data.token;
  const idEvent = location.state.idEvent;

  const [packages, setPackages] = useState([]);
  const [packEdit, setPackEdit] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [countData, setCountData] = useState(1);
  const [search, setSearch] = useState("");
  const [activeCps, setActiveCps] = useState(true);
  const [order, setOrder] = useState("name");
  const [sort, setSort] = useState("asc");

  const [isLoading, setIsLoading] = useState(false);

  const [newPackage, setNewPackage] = useState(false);
  const [editPackage, setEditPackage] = useState(false);

  const getPackages = async () => {
    setIsLoading(true);
    try {
      const data = await fetchPackages(
        token,
        currentIndex > 0 ? currentIndex : 1,
        itemsPerPage,
        search,
        "",
        idEvent,
        activeCps,
        order,
        sort
      );

      setPackages(data.packages);
      setCountData(data.total);
    } catch (error) {
      console.error("Erro ao buscar pacotes:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getPackages();
  }, [search, currentIndex, itemsPerPage, activeCps, order, sort]);

  const handleSort = (column) => {
    if (order === column) {
      setSort(sort === "asc" ? "desc" : "asc");
    } else {
      setOrder(column);
      setSort("asc");
    }
  };

  return (
    <>
      <Card>
        <CardBody>
          <CardTitle>Pacotes de Quarto</CardTitle>

          {newPackage && (
            <ModalNewPackage
              isOpen={newPackage}
              toggle={() => setNewPackage(false)}
              jwt={token}
              refetch={getPackages}
              eventId={idEvent}
            />
          )}

          {editPackage && (
            <ModalEditPackage
              isOpen={editPackage}
              toggle={() => setEditPackage(false)}
              jwt={token}
              refetch={getPackages}
              eventId={idEvent}
              packageData={packEdit}
            />
          )}

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: 10,
            }}
          >
            <input
              type="text"
              value={search}
              placeholder="Pesquisar..."
              className="form-control"
              style={{ maxWidth: 300 }}
              onChange={(e) => setSearch(e.target.value)}
            />

            <div className="header-btns-container">
              {/* <Button
                color="secondary"
                className="btn-rounded waves-effect waves-light events-button-add-lg"
                onClick={() => {
                  setActiveCps(!activeCps);
                }}
              >
                {!activeCps ? "Filtrar: Ativos" : "Filtrar: Inativos"}
              </Button> */}

              <ActionButtonRounded
                title="Novo Pacote"
                onClick={() => setNewPackage(true)}
              />
            </div>
          </div>

          <div className="table-responsive">
            <Table className="table mb-0">
              <thead className="thead-light">
                <tr>
                  <th
                    onClick={() => handleSort("name")}
                    style={{ cursor: "pointer" }}
                  >
                    Descrição
                  </th>
                  <th
                    onClick={() => handleSort("code")}
                    style={{ cursor: "pointer" }}
                  >
                    Código
                  </th>
                  <th
                    onClick={() => handleSort("quantity_available")}
                    style={{ cursor: "pointer" }}
                  >
                    Quantidade
                  </th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <LoadingSkelentonTable lines={10} cols={4} />
                ) : (
                  packages.map((item, index) => (
                    <tr key={index}>
                      <td>{item.description}</td>
                      <td>{item.code}</td>
                      <td>{item.available || 0}</td>

                      <td>
                        <i
                          className="mdi mdi-pencil"
                          style={{
                            color: "green",
                            fontSize: 17,
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setPackEdit(item);
                            setEditPackage(true);
                          }}
                        />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>

      <Pagination
        data={packages}
        currentIndex={currentIndex}
        setCurrentIndex={setCurrentIndex}
        countData={countData}
        maxItemPerPage={itemsPerPage}
        setMaxItemPerPage={setItemsPerPage}
        maxPageButtonsToShow={3}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(PackagesPerGroup);
